import React, { useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Link,
  Skeleton,
  Box,
  Chip,
  Typography,
} from "@mui/material";

const toolImages = {
  aws: [
    "https://spacelift.io/_next/image?url=https%3A%2F%2Fspacelift.io%2Fwp-content%2Fuploads%2F2023%2F07%2F224.who-is-using-aws-2023.png&w=3840&q=75",
    "https://pimwp.s3-accelerate.amazonaws.com/2022/08/1cb5fffe7b72fd0c0f4906c1038deda1505ad81d-1600x1000-1.png",
    "https://assets.community.aws/a/2nNAa2jLn2po8xQMe2nCYkPsHlc/Amaz.webp?imgSize=3000x2000",
  ],
  azure: [
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHMJRA2MfI1TqsX49idcohxXQ5iBWYovbr0g&s",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2mg4ttjTy5PrTZeyE9XuiOhwHY-x16W3LFg&s",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBLyhk3puqYJ3CLqjSdol6FhuCYhqoiU6lDg&s",
  ],
  gcp: [
    "https://images.unsplash.com/photo-1600267165477-6d4c0c3e6b4c",
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31",
  ],
  docker: [
    "https://bunnyacademy.b-cdn.net/what-is-docker.png",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRljKAMI0SujcNGgDbYrtc00UOsrV4RY6-_iQ&s",
    "https://fs.buttercms.com/resize=width:885/60rkSQqZRrejdedGfkdc",
  ],
  kubernetes: [
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWEU0fNllsyzmdohjJhmy_Re1Fp2q8IIgWHQ&s",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrqUG3BL5_7Lf_FT8lS-2w9EL4k7BxXaDMNg&s",
    "https://static.learnkube.com/f94c971397a8bd53d4ef21b74233cbd4.png",
  ],
  ansible: [
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYdD92db3gKoS1x73eVxvakB9AGDfh7Es40Q&s",
    "https://www.mygreatlearning.com/blog/wp-content/uploads/2022/08/Untitled-design-2.png",
    "https://miro.medium.com/1*OG_B4TvI6yyKQ4wYcFzvhw.png",
  ],
  terraform: [
    "https://spacelift.io/wp-content/uploads/2023/07/244.terraform-cloud-overview.png",
    "https://cdn.prod.website-files.com/5db35de024bb988f5fb4e168/6616841f741edaf919f6d645_63b599af993685188b65fc17_6278caa9a197cc0d36db6360_1147_Terraform%252520Cloud%252520Part%2525204.jpeg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5M8oCrTyvJEjXUqD1I8SqfapEzwJioOLLRw&s",
  ],
  jenkins: [
    "https://miro.medium.com/1*xbczoyccb92qbh8WI0eUSw.png",
    "https://cdn.prod.website-files.com/681e366f54a6e3ce87159ca4/6877c48e862b0bdd55ba3a76_container-image-scanning-jenkins-sysdig-00.png",
    "https://spacelift.io/_next/image?url=https%3A%2F%2Fspacelift.io%2Fwp-content%2Fuploads%2F2024%2F07%2F405.-jenkins-tutorial.png&w=3840&q=75",
  ],
  git: [
    "https://img.magnific.com/premium-vector/black-white-sign-that-says-x-it_1315804-2406.jpg?semt=ais_hybrid&w=740&q=80",
    "https://cdn-icons-png.flaticon.com/512/2111/2111432.png",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToe0l-0KLyx6JieGAzMvk4agH-sjPkWtNs9A&s",
  ],
  linux: [
    "https://images.unsplash.com/photo-1517433456452-f9633a875f6f",
    "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
    "https://images.unsplash.com/photo-1593642532973-d31b6557fa68",
  ],
  python: [
    "https://images.unsplash.com/photo-1526379095098-d400fd0bf935",
    "https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
    "https://images.unsplash.com/photo-1555066931-4365d14bab8c",
  ],
  devops: [
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTo5FT1nmTu7f-h-_g2fmEt2Mknn7PLS9h4fA&s",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqWMb0-PE0GKX-zYhZ5Lr5FcIC0XT7OPU-jQ&s",
    "https://img.magnific.com/free-vector/flat-design-technology-devops-illustration_23-2149356401.jpg?semt=ais_hybrid&w=740&q=80",
  ],
  cicd: [
    "https://images.unsplash.com/photo-1555949963-fc4b8ecde1c0",
    "https://images.unsplash.com/photo-1581090700227-4c4f50cbb1c4",
    "https://images.unsplash.com/photo-1605379399642-870262d3d051",
  ],
  monitoring: [
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
    "https://images.unsplash.com/photo-1581091012184-5c3aef6d77b3",
    "https://images.unsplash.com/photo-1599658880436-c61792e70672",
  ],
  default: [
    "https://images.unsplash.com/photo-1518770660439-4636190af475",
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
    "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
  ],
};

const keywords = [
  "aws",
  "azure",
  "gcp",
  "docker",
  "kubernetes",
  "ansible",
  "terraform",
  "jenkins",
  "git",
  "linux",
  "python",
  "devops",
  "ci/cd",
  "cicd",
  "monitoring",
];


/* ---------------- SAFE RANDOM PICK ---------------- */
const getRandomImage = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return toolImages.default[0];
  }
  return arr[Math.floor(Math.random() * arr.length)];
};

/* ---------------- IMAGE RESOLVER ---------------- */
const getImageFromText = (text = "") => {
  const lower = text.toLowerCase();

  let matchedKey = null;

  for (let key of keywords) {
    if (lower.includes(key)) {
      matchedKey = key;
      break;
    }
  }

  // normalize key
  if (matchedKey === "ci/cd") matchedKey = "cicd";

  const images =
    (matchedKey && toolImages[matchedKey]) ||
    toolImages.default;

  return getRandomImage(images);
};

/* ---------------- COMPONENT ---------------- */
export default function DynamicBlogCard({ blog, isSmallScreen }) {
  const [loading, setLoading] = useState(true);

  const [imgSrc, setImgSrc] = useState(() =>
    getImageFromText(
      `${blog?.title || ""} ${blog?.description || ""}`
    )
  );

  const handleClick = () => {
    window.open(`/blog/${blog?.slug}`, "_self");
  };

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        bgcolor: "#fff",
        color: "#111827",
        fontFamily: "'Poppins', sans-serif",
        borderRadius: "12px",
        cursor: "pointer",
        overflow: "hidden",
        border: "1px solid rgba(15,23,42,0.08)",
        boxShadow: "0 12px 30px rgba(15,23,42,0.06)",
        transition: "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
        "&:hover": {
          transform: isSmallScreen ? "none" : "translateY(-5px) scale(1.015)",
          boxShadow: "0 18px 42px rgba(15,23,42,0.1)",
          borderColor: "rgba(178,85,255,0.65)",
        },
        "& *": {
          fontFamily: "'Poppins', sans-serif !important",
        },
      }}
      onClick={handleClick}
    >
      <Box sx={{ position: "relative", height: 194, bgcolor: "#eef2f7" }}>
        {loading && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={194}
            animation="wave"
            sx={{ bgcolor: "rgba(15,23,42,0.08)" }}
          />
        )}

        <CardMedia
          component="img"
          height="194"
          image={imgSrc}
          alt={blog?.title || "blog-image"}
          loading="lazy"
          onLoad={() => setLoading(false)}
          onError={() => {
            setImgSrc(getRandomImage(toolImages.default));
            setLoading(false);
          }}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            objectFit: "cover",
            opacity: loading ? 0 : 1,
            transition: "opacity 0.4s ease-in-out",
            filter: "saturate(1.08) contrast(1.03)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: "linear-gradient(180deg, rgba(255,255,255,0) 46%, rgba(15,23,42,0.62) 100%)",
          }}
        />
        <Chip
          label="New"
          size="small"
          sx={{
            position: "absolute",
            left: 10,
            bottom: 10,
            background:
              "radial-gradient(92.09% 85.42% at 86.3% 87.5%, rgba(0, 0, 0, 0.23) 0%, rgba(0, 0, 0, 0) 86.18%), radial-gradient(65.28% 65.28% at 26.39% 20.83%, rgba(255, 255, 255, 0.413) 0%, rgba(255, 255, 255, 0) 69.79%, rgba(255, 255, 255, 0) 100%), #8C00FF",
            color: "#fff",
            borderRadius: "4px",
            fontSize: "0.68rem",
            fontWeight: 500,
            height: 24,
          }}
        />
      </Box>

      <CardContent sx={{ minHeight: 92, p: 1.75, pb: 0.5 }}>
        <Typography
          sx={{
            color: "#111827",
            fontFamily: "'Poppins', sans-serif",
            fontSize: "0.92rem",
            fontWeight: 500,
            lineHeight: 1.35,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {blog?.title
            ?.split(" ")
            ?.slice(0, 10)
            ?.join(" ") +
            (blog?.title?.split(" ").length > 10 ? "..." : "")}
        </Typography>
      </CardContent>

      <CardActions disableSpacing sx={{ px: 1.75, pb: 1.5, pt: 0 }}>
        <Link
          underline="hover"
          sx={{
            color: "#8C00FF",
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          Read More
        </Link>
      </CardActions>
    </Card>
  );
}
